.overlay-icon {
  filter: drop-shadow(0px 0px 5px rgb(0 0 0 / 95%));
}
